import React, { Component } from "react";

export default class LoadSvg extends Component {
  static defaultProps = {
    file: null,
    onLoaded: () => null
  };
  constructor(props) {
    super(props);
    this.state = {
      svg: null
    };
  }
  componentDidMount() {
    this.init();
  }
  init = async () => {
    const { file } = this.props;
    const svg = await fetch(file)
      .then(res => res.text())
      .catch(error => console.log("error fetch", file, error));
    this.setState({ svg });
    this.props.onLoaded();
  };
  render() {
    const { svg } = this.state;
    if (!svg) return null;
    return <div dangerouslySetInnerHTML={{ __html: svg }} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadSvg.js